import React from 'react';
import { Category, Project, UserDetails } from '../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faUser } from '@fortawesome/free-regular-svg-icons';
import { formatDate } from '../utils/timeUtils';
// import useNumberItems from '../hooks/useNumberItems';

interface ProjectCardProps {
    project: Project;
    userDetails: UserDetails | null;
    onSelect: (project: Project) => void;
}

export function getColorForCategory(category: Category): string {
    const colorMap: { [key in Category]: string } = {
        Food: '89, 68, 253',
        Wine: '255, 87, 51',
        Beverage: '50, 205, 50',
    };

    return colorMap[category];
}

const ProjectCard: React.FC<ProjectCardProps> = ({
    project,
    onSelect,
    userDetails,
}) => {
    const userName = userDetails
        ? `${userDetails.first_name} ${userDetails?.last_name}`
        : 'Unknown User';

    return (
        <div className="spec-card" onClick={() => onSelect(project)}>
            <div className="upper-container">
                <div className="category-container">
                    <p
                        className="category"
                        style={{
                            color: `rgb(${getColorForCategory(project.metadata.category)})`,
                            backgroundColor: `rgba(${getColorForCategory(
                                project.metadata.category,
                            )}, 0.2)`,
                        }}
                    >
                        {project.metadata.category}
                    </p>
                    {/* <button>
                        <FontAwesomeIcon icon={faEllipsisV} />
                    </button> */}
                </div>
                <p className="spec-name">{project.name}</p>
                {/* {project.spec_notes && (
                    <p className="spec-notes">{project.spec_notes}</p>
                )} */}
            </div>
            <div className="lower-container">
                <div className="icon-value-container">
                    <FontAwesomeIcon icon={faCalendar} />
                    <p>{formatDate(project.creation.timestamp, false, true)}</p>
                </div>
                {userName && (
                    <div className="icon-value-container">
                        <FontAwesomeIcon icon={faUser} />
                        <p>{userName}</p>
                    </div>
                )}
                {/* <div className="icon-value-container">
                    <FontAwesomeIcon icon={faHashtag} />
                    <p>{1}</p>
                </div> */}
            </div>
        </div>
    );
};

export default ProjectCard;
